var React = require('react');

function IconPenSolidO (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M164.6 38.6l-19.2-16.3c-8.8-7.4-21.9-6.2-29.3 2.6l-29 34.6c-2.4 2.9-2 7.1.8 9.5 2.9 2.4 7.2 2 9.5-.8l14-16.7 30.2 25.6-56.5 67.4L54.9 119l25.3-30.2c2.4-2.9 2-7.1-.8-9.6-2.9-2.4-7.1-2-9.6.8l-32.1 38.2c-2.5 3-4.1 6.6-4.6 10.4l-7.6 35.7c-.3 2.1-.1 4.3.5 6.3 1.9 5.8 7.3 9.5 13.1 9.5 1.4 0 2.9-.2 4.3-.7l35.9-11.8c3.7-1.2 6.9-3.4 9.4-6.4l78.4-93.4c7.4-8.7 6.3-21.8-2.5-29.2zm-44.4 2.6l6.3-7.6c1.2-1.5 3-2.4 4.9-2.5 1.9-.2 3.8.4 5.3 1.7L155.9 49c3 2.6 3.4 7.1.9 10.2l-6.4 7.6-30.2-25.6zM38.9 166.3l7.6-35.7c0-.3.3-.5.3-.7l28.9 24.4c-.2.1-.4.4-.6.4l-36.2 11.6z"}));
}

IconPenSolidO.displayName = "IconPenSolidO";

IconPenSolidO.defaultProps = {"viewBox":"0 0 200 200"};

module.exports = IconPenSolidO;

IconPenSolidO.default = IconPenSolidO;
